import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig(source) {
    return {
      cancelToken: source?.token,
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static createWONote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/wo/create", requestData, this.requestConfig());
  }

  static createMainNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/main/create", requestData, this.requestConfig());
  }

  static createCallCustomerNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/call/create", requestData, this.requestConfig());
  }

  static createAttachmentNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/attachment/create", requestData, this.requestConfig());
  }

  static createRecurringCarNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/recurring_car/create", requestData, this.requestConfig());
  }

  static createParkingNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/parking/create", requestData, this.requestConfig());
  }

  static updateParkingNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/parking/update", requestData, this.requestConfig());
  }

  static updateWONote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/wo/update", requestData, this.requestConfig());
  }

  static updateMainNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/main/update", requestData, this.requestConfig());
  }

  static updateCallCustomerNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/call/update", requestData, this.requestConfig());
  }

  static updateAttachmentNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/attachment/update", requestData, this.requestConfig());
  }

  static updateRecurringCarNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/recurring_car/update", requestData, this.requestConfig());
  }

  static deleteAppointmentNote(appointment_note_id) {
    return axios.post(ENV.appointmentApiBase + "/notes/delete", { appointment_note_id }, this.requestConfig());
  }

  static getAppointments(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/list_daily", requestData, this.requestConfig());
  }

  static getAppointment(id) {
    // hack
    id = parseInt(id, 10);
    return axios.post(
      ENV.appointmentApiBase + "/appointments/view",
      { id, embed: "appointment_status,customer_owner,customer_driver,car,customer_contract,customcom,pin,snooze,deskcom,keycom,kioskcom" },
      this.requestConfig()
    );
  }

  static getAppointmentByWo(wo, dealer_location_id) {
    return axios.post(
      ENV.appointmentApiBase + "/appointments/view_by_wo",
      { wo, dealer_location_id, embed: "appointment_status,customer_owner,customer_driver,car,customer_contract,customcom,pin,snooze,deskcom" },
      this.requestConfig()
    );
  }

  static cancelAppointment(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_cancel", requestData, this.requestConfig());
  }

  static createAppointment(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/create", requestData, this.requestConfig());
  }

  static getAppointmentChecks(id) {
    return axios.post(ENV.appointmentApiBase + `/checks/list`, { appointment_id: id, embed: "pin,snooze" }, this.requestConfig());
  }

  static updateIntervention(requestData) {
    return axios.post(ENV.appointmentApiBase + "/interventions/update", requestData, this.requestConfig());
  }

  static addIntervention(requestData) {
    return axios.post(ENV.appointmentApiBase + "/interventions/add", requestData, this.requestConfig());
  }

  static deleteIntervention(id) {
    return axios.post(ENV.appointmentApiBase + "/interventions/delete", { id }, this.requestConfig());
  }

  static setMakeAnOffer(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_make_offer", requestData, this.requestConfig());
  }

  static setAppointmentBackorderStatus(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_backorder", requestData, this.requestConfig());
  }

  static setAppointmentDiagnoseStatus(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_info", requestData, this.requestConfig());
  }

  static setCarReadyStatus(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_car_ready", requestData, this.requestConfig());
  }

  static setCustomerOKStatus(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_customer_ok", requestData, this.requestConfig());
  }

  static setContactStatus(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_contact", requestData, this.requestConfig());
  }

  static setPricingOKStatus(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_pricing_ok", requestData, this.requestConfig());
  }

  static setCarInShopStatus(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/set_car_in_shop", requestData, this.requestConfig());
  }

  static setCarOutOfShopStatus(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/set_car_out_of_shop", requestData, this.requestConfig());
  }

  static updateQuestion(requestData) {
    return axios.post(ENV.appointmentApiBase + "/checks/question_result/update", requestData, this.requestConfig());
  }

  static updateQuestionResultRemark(requestData) {
    return axios.post(ENV.appointmentApiBase + "/checks/remark/update", requestData, this.requestConfig());
  }

  static getDefaultStatuses() {
    return axios.get(ENV.dealerBaseUrl + "/app_statuses/list", this.requestConfig());
  }

  static getChecklistReport(check_id) {
    let config = this.requestConfig();
    config = {
      ...config,
      responseType: "blob",
    };

    return axios.post(ENV.appointmentApiBase + "/pdfs/download", { check_id }, config);
  }

  static downloadPdfPreview(requestData) {
    let config = this.requestConfig();
    config = {
      ...config,
      responseType: "blob",
    };

    return axios.post(ENV.appointmentApiBase + "/repair_overview/preview/download", requestData, config);
  }

  static downloadPdfCarReadySent(requestData) {
    let config = this.requestConfig();
    config = {
      ...config,
      responseType: "blob",
    };

    return axios.post(ENV.customComBaseUrl + "/repair_overview/download", requestData, config);
  }

  static getHtmlPreview(requestData) {
    return axios.post(ENV.appointmentApiBase + "/repair_overview/preview/url", requestData, this.requestConfig());
  }

  static getChecklistReportUrl(check_id) {
    return axios.post(ENV.appointmentApiBase + "/pdfs/url", { check_id }, this.requestConfig());
  }

  static searchAppointments(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/search", requestData, this.requestConfig());
  }

  static getCustomers(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/customers/list", requestData, this.requestConfig());
  }

  static searchCarsByCustomer(requestData) {
    return axios.post(ENV.carBaseUrl + "/cars/search/customer_id", requestData, this.requestConfig());
  }

  static getCarSnoozedItems(requestData) {
    return axios.post(ENV.appointmentApiBase + "/snoozes/list_by_car_id", requestData, this.requestConfig());
  }

  static createCustomcom(requestData) {
    return axios.post(ENV.appointmentApiBase + "/diagnose_overview/create", requestData, this.requestConfig());
  }

  static updateCustomcom(requestData) {
    return axios.post(ENV.appointmentApiBase + "/diagnose_overview/update", requestData, this.requestConfig());
  }

  static createPostCustomcom(requestData) {
    return axios.post(ENV.appointmentApiBase + "/repair_overview/create", requestData, this.requestConfig());
  }

  static updatePostCustomcom(requestData) {
    return axios.post(ENV.appointmentApiBase + "/repair_overview/update", requestData, this.requestConfig());
  }

  static getDBBLink(requestData) {
    return axios.post(ENV.appointmentApiBase + "/dbb/portal", requestData, this.requestConfig());
  }

  static refreshDBB(requestData) {
    return axios.post(ENV.appointmentApiBase + "/dbb/refresh", requestData, this.requestConfig());
  }

  static getDBBTyreLimits(requestData) {
    return axios.post(ENV.appointmentApiBase + "/dbb/tyre_limits/list", requestData, this.requestConfig());
  }

  static updateDBBAppointmentDate(requestData) {
    return axios.post(ENV.appointmentApiBase + "/dbb/appointment_date/update", requestData, this.requestConfig());
  }

  static createDBBContract(requestData) {
    return axios.post(ENV.appointmentApiBase + "/dbb/contracts/create", requestData, this.requestConfig());
  }

  static deleteChecklist(appointment_id) {
    return axios.post(ENV.appointmentApiBase + "/checks/last/delete", { appointment_id }, this.requestConfig());
  }

  static getTyresSizes() {
    return axios.get(ENV.carBaseUrl + "/tyres/dimensions/list", this.requestConfig());
  }

  static updateTyresReplacement(request_data) {
    return axios.post(ENV.carBaseUrl + "/tyres/replacements/update", request_data, this.requestConfig());
  }

  static deleteTyresReplacement(request_data) {
    return axios.post(ENV.carBaseUrl + "/tyres/replacements/delete", request_data, this.requestConfig());
  }

  static handleCheckInResult(request_data) {
    return axios.post(ENV.appointmentApiBase + "/check_in/result/handle", request_data, this.requestConfig());
  }

  static handleCheckInRemark(request_data) {
    return axios.post(ENV.appointmentApiBase + "/check_in/remark/handle", request_data, this.requestConfig());
  }

  static handleKeyLockerRemark(request_data) {
    return axios.post(ENV.keylockerBase + "/dashboard/remark/handle", request_data, this.requestConfig());
  }

  static handleKioskRemark(request_data) {
    return axios.post(ENV.kioskBaseUrl + "/dashboard/remark/handle", request_data, this.requestConfig());
  }

  static handleCustomComRemark(request_data) {
    return axios.post(ENV.appointmentApiBase + "/diagnose_overview/remark/handle", request_data, this.requestConfig());
  }

  static getCarByRegNum(reg_nr, location_id) {
    return axios.post(ENV.carBaseUrl + "/cars/search/regnr", { reg_nr, location_id }, this.requestConfig());
  }

  static createDeskCheckin(requestData) {
    let source = axios.CancelToken.source();
    return { request: axios.post(ENV.dcBaseUrl + "/receptionists/create", requestData, this.requestConfig(source)), token: source };
  }

  static cancelDeskCheckin(desk_communication_id) {
    return axios.post(ENV.dcBaseUrl + "/receptionists/cancel", { desk_communication_id }, this.requestConfig());
  }

  static getSnoozeAppointmentHistory(requestData) {
    return axios.post(ENV.appointmentApiBase + "/snoozes/appointment_history", requestData, this.requestConfig());
  }

  static getCancelAppointmentReasons() {
    return axios.get(ENV.appointmentApiBase + "/status/cancel_reasons", this.requestConfig());
  }

  static getAdvisedCriticalHistory(requestData) {
    return axios.post(ENV.appointmentApiBase + "/leads/advised_critical_history", requestData, this.requestConfig());
  }

  static searchTyreTeamTires(requestData) {
    return axios.post(ENV.tyreteamBaseURL + "/catalog/search", requestData, this.requestConfig());
  }

  static searchTires(requestData) {
    return axios.post(ENV.carBaseUrl + "/tyres/search", requestData, this.requestConfig());
  }

  static addTyreTeamReplacements(requestData) {
    return axios.post(ENV.tyreteamBaseURL + "/replacements/replacements/create", requestData, this.requestConfig());
  }

  static addTiresReplacements(requestData) {
    return axios.post(ENV.carBaseUrl + "/tyres/replacements/add", requestData, this.requestConfig());
  }

  static getTyreTeamStock(requestData) {
    return axios.post(ENV.tyreteamBaseURL + "/catalog/stock", requestData, this.requestConfig());
  }

  static getTiresBrands() {
    return axios.get(ENV.carBaseUrl + "/tyres/brands/list", this.requestConfig());
  }

  static getTyreTeamBrands(requestData) {
    return axios.post(ENV.tyreteamBaseURL + "/catalog/brands/list", requestData, this.requestConfig());
  }

  static tyreTeamPlaceOrder(requestData) {
    return axios.post(ENV.tyreteamBaseURL + "/catalog/order", requestData, this.requestConfig());
  }

  static getDeliveryTypes(requestData) {
    return axios.post(ENV.tyreteamBaseURL + "/catalog/delivery_types/list", requestData, this.requestConfig());
  }

  static getAppointmentDetailLog(appointment_id) {
    return axios.post(ENV.appointmentApiBase + "/logs/view", { appointment_id }, this.requestConfig());
  }

  static getCar(carID) {
    return axios.post(ENV.carBaseUrl + "/cars/details", { id: carID }, this.requestConfig());
  }

  static uploadNoteAttachment(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/attachment/upload", requestData, this.requestConfig());
  }

  static uploadCheckVideos(requestData) {
    return axios.post(ENV.appointmentApiBase + "/checks/file/upload", requestData, this.requestConfig());
  }

  static getDiscounts(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/tyre_discounts/list_discounts", requestData, this.requestConfig());
  }

  static createBillNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/bill/create", requestData, this.requestConfig());
  }

  static updateBillNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/bill/update", requestData, this.requestConfig());
  }

  static createTempDriverNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/temp_driver/create", requestData, this.requestConfig());
  }

  static updateTempDriverNote(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/temp_driver/update", requestData, this.requestConfig());
  }

  static getAllAppointmentAttachments(requestData) {
    return axios.post(ENV.appointmentApiBase + "/notes/attachment/url/list", requestData, this.requestConfig());
  }

  static updateIsAppointmentPinned(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/is_pinned/update", requestData, this.requestConfig());
  }

  static updateOnlineCheckinRemark(requestData) {
    return axios.post(ENV.appointmentApiBase + "/check_in/remark/update", requestData, this.requestConfig());
  }

  static updateDiagnoseRemark(requestData) {
    return axios.post(ENV.appointmentApiBase + "/diagnose_overview/remark/update", requestData, this.requestConfig());
  }

  static updateKeylockerRemark(requestData) {
    return axios.post(ENV.keylockerBase + "/dashboard/remark/update", requestData, this.requestConfig());
  }

  static updateKioskCheckinRemark(requestData) {
    return axios.post(ENV.kioskBaseUrl + "/dashboard/remark/update", requestData, this.requestConfig());
  }

  static restoreCanceledAppointemnt(requestData) {
    return axios.post(ENV.appointmentApiBase + "/status/set_new_car", requestData, this.requestConfig());
  }

  static kioskLabelDetach(requestData) {
    return axios.post(ENV.kioskBaseUrl + "/dashboard/labels/detach", requestData, this.requestConfig());
  }

  static updateCustomerWaiting(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/set_customer_waiting", requestData, this.requestConfig());
  }

  static sendOnlineCheckin(requestData) {
    return axios.post(ENV.appointmentApiBase + "/online_checkin/create", requestData, this.requestConfig());
  }

  static handleDmsRefresh(requestData) {
    return axios.post(ENV.dmsWeb + "/appointments/refresh", requestData, this.requestConfig());
  }

  static handleImportDMSAppointment(requestData) {
    return axios.post(ENV.dmsWeb + "/appointments/import", requestData, this.requestConfig());
  }

  static updateDates(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/update_dates", requestData, this.requestConfig());
  }

  static updateMileages(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/update_mileages", requestData, this.requestConfig());
  }

  static updateBilling(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/update_billing", requestData, this.requestConfig());
  }

  static updateStar(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/update_star", requestData, this.requestConfig());
  }

  static updateShoppingCart(requestData) {
    return axios.post(ENV.appointmentApiBase + "/appointments/update_shopping_cart", requestData, this.requestConfig());
  }
}

export default Service;
